import { VideoSlider } from '@/components/VideoSlider';
import gridBreakpoints from 'base/configs/grid.breakpoints';
import { VIDEO_PAGES_CONFIG } from 'base/configs/video';
import { SECTIONS, VideoFrontSection } from './types';

const maximumIndexForDisablingLazyLoad = 2;

export const getVideoSections = (sections: VideoFrontSection[]) => {
  return sections.map((section, index) => {
    const disableLazyLoad = maximumIndexForDisablingLazyLoad > index;
    const imageLoadingType = disableLazyLoad ? 'eager' : 'lazy';

    switch (section.type) {
      case SECTIONS.SHOWS: {
        return (
          <VideoSlider
            title={VIDEO_PAGES_CONFIG.frontPage.showsSectionTitle}
            url="/video/show"
            key={section.type}
            slides={section.data?.[0]?.playlist?.map((p) => ({ ...p, isImage: true }))}
            options={{
              $swiper: {
                breakpoints: {
                  [gridBreakpoints.xs]: {
                    slidesPerView: 2.5,
                  },
                  [gridBreakpoints.sm]: {
                    slidesPerView: 3.5,
                  },
                  [gridBreakpoints.md]: {
                    slidesPerView: 3.5,
                  },
                  [gridBreakpoints.lg]: {
                    slidesPerView: 4,
                  },
                },
              },
              $teaser: {
                $media: {
                  $image: {
                    loading: imageLoadingType,
                  },
                  $video: {
                    disableLazyLoad,
                  },
                },
              },
            }}
          />
        );
      }

      case SECTIONS.NEW: {
        return section.data.map(({ playlist, title, description }) => (
          <VideoSlider
            title={VIDEO_PAGES_CONFIG.frontPage.newsSectionTitle ?? title}
            key={title}
            options={{
              $header: {
                $arrow: { className: 'hidden' },
              },
              $teaser: {
                $media: {
                  $image: {
                    loading: imageLoadingType,
                  },
                  $video: {
                    disableLazyLoad,
                  },
                },
              },
            }}
            description={description}
            slides={playlist}
          />
        ));
      }

      case SECTIONS.TRENDING: {
        return section.data.map(({ playlist, title, description }) => (
          <VideoSlider
            title={VIDEO_PAGES_CONFIG.frontPage.trendingSectionTitle ?? title}
            key={title}
            options={{
              $header: {
                $arrow: { className: 'hidden' },
              },
              $teaser: {
                $media: {
                  $image: {
                    loading: imageLoadingType,
                  },
                  $video: {
                    disableLazyLoad,
                  },
                },
              },
            }}
            description={description}
            slides={playlist}
          />
        ));
      }

      case SECTIONS.TAGS: {
        return section.data.map(({ playlist, title, url, description }) => (
          <VideoSlider
            title={title}
            key={title}
            url={url}
            description={description}
            slides={playlist}
            options={{
              $teaser: {
                $media: {
                  $image: {
                    loading: imageLoadingType,
                  },
                  $video: {
                    disableLazyLoad,
                  },
                },
              },
            }}
          />
        ));
      }

      default: {
        return null;
      }
    }
  });
};
